import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "../css/FieldForce.css";
import { BASE_URL } from "../config";
import { getAuthHeaders } from "../services/useAuth";
import CustomButton from "../pages/CustomButton";
import Loader from "../dist/Loader";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
const DoctorsInTPvsDCR = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const tableRef = useRef();
  const params = new URLSearchParams(location.search);
  const workingDateParam = params.get("working_date");
  const employeeId = params.get("employee_id");
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const formatDateToISO = (dateString) => {
    if (!dateString) return "";
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      return dateString;
    }
    const [month, day, year] = dateString.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  };
  useEffect(() => {
    if (!workingDateParam || !employeeId) return;

    const fetchData = async () => {
      try {
        setLoading(true);

        const formattedDate = formatDateToISO(workingDateParam);
        const response = await axios.get(
          `${BASE_URL}/api/reports/tp-vs-dcr`,
          {
            params: {
              working_date: formattedDate,
              employee_id: employeeId,
            },
            headers: getAuthHeaders(),
          }
        );
        setReport(response.data);
      } catch (error) {
        console.error("API Error:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [workingDateParam, employeeId]);

  // ================= PRINT FUNCTION =================
  const handlePrint = () => {
    if (!tableRef.current) return;

    const printContent = tableRef.current.innerHTML;
    const newWindow = window.open("", "", "width=1000,height=800");

    newWindow.document.write(`
      <html>
        <head>
          <title>TP vs DCR Report</title>
          <style>
            body { font-family: Arial, sans-serif; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid black; padding: 8px; font-size: 12px; }
            th { background-color: #f2f2f2; }
            h3 { text-align: center; }
          </style>
        </head>
        <body>
          <h3>TP vs DCR Report</h3>
          ${printContent}
        </body>
      </html>
    `);

    newWindow.document.close();
    newWindow.focus();
    newWindow.print();
    newWindow.close();
  };

  // ================= EXPORT FUNCTION =================
  const handleExport = () => {
    if (!report) return;

    const tpDoctors =
      report.tp?.retailers
        ?.filter((r) => r.retailer_type === "Doctor")
        .map((r) => r.name)
        .join(", ") || "";

    const dcrDoctors =
      report.dcr?.retailers
        ?.filter((r) => r.retailer_type === "Doctor")
        .map((r) => r.name)
        .join(", ") || "";

    const dcrVisitTimes =
      report.dcr?.retailers
        ?.filter((r) => r.retailer_type === "Doctor")
        .map((r) => r.visit_time)
        .join(", ") || "";

    const dcrWorkingWith =
      report.dcr?.retailers
        ?.filter((r) => r.retailer_type === "Doctor")
        .map((r) => r.working_with)
        .join(", ") || "";

    const data = [
      {
        "Working Date": report.working_date,
        "Employee Name": report.employee_name,
        "TP Route": report.tp?.route,
        "TP Doctors": tpDoctors,
        "TP Working With": report.tp?.working_with,
        "DCR Route": report.dcr?.route_covered?.join(", "),
        "DCR Doctors": dcrDoctors,
        "Visit Time": dcrVisitTimes,
        "DCR Working With": dcrWorkingWith,
      },
    ];

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "TPvsDCR");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(blob, `TP_vs_DCR_${report.working_date}.xlsx`);
  };

  if (loading) return <Loader />;

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h2 className="text-center font-semibold text-lg mb-4">
        Doctors In ( <span className="font-bold">TP Vs DCR</span> )
      </h2>
      <div
        ref={tableRef}
        className="overflow-x-auto bg-white border shadow"
      >
        <table className="min-w-full border-collapse text-sm text-left">
          <thead>
            <tr className="bg-blue-500 text-white text-center">
              <th rowSpan="2" className="border px-3 py-2">S.No</th>
              <th rowSpan="2" className="border px-4 py-2">
                Working Date
              </th>
              <th colSpan="4" className="border px-4 py-2">TP</th>
              <th colSpan="5" className="border px-4 py-2">DCR</th>
            </tr>
            <tr className="bg-teal-200 text-black text-center">
              <th className="border px-3 py-2">Route</th>
              <th className="border px-3 py-2">Doctor</th>
              <th className="border px-3 py-2">Working With</th>
              <th className="border px-3 py-2">Remarks</th>
              <th className="border px-3 py-2">Route</th>
              <th className="border px-3 py-2">Doctor</th>
              <th className="border px-3 py-2">Visit Time</th>
              <th className="border px-3 py-2">Working With</th>
              <th className="border px-3 py-2">Remarks</th>
            </tr>
          </thead>
          <tbody>
            {!report ? (
              <tr>
                <td colSpan="11" className="text-center py-4">
                  No Data Found
                </td>
              </tr>
            ) : (
              <tr className="align-top">
                <td className="border px-3 py-4 text-center">1</td>

                <td className="border px-4 py-4 text-center">
                  {report.working_date}
                </td>

                <td className="border px-4 py-4">
                  {report.tp?.route}
                </td>
                <td className="border px-4 py-4">
                  {report.tp?.retailers
                    ?.filter((r) => r.retailer_type === "Doctor")
                    .map((doc, i) => (
                      <div key={i}>{i + 1}. {doc.name}</div>
                    ))}
                </td>
                <td className="border px-4 py-4">
                  {report.tp?.working_with}
                </td>
                <td className="border px-4 py-4">-</td>
                <td className="border px-4 py-4">
                 {report.dcr?.route_covered?.join(", ")}
                </td>
                <td className="border px-4 py-4">
                   {report.dcr?.retailers?.map((retailer, i) => (
                    <div key={i}>
                    {i + 1}. {retailer.name} ({retailer.retailer_type})
                    </div>
                ))}
                </td>
                <td className="border px-4 py-4">
                  {report.dcr?.retailers?.map((retailer, i) => (
                    <div key={i}>
                    {i + 1}. {retailer.visit_time || "-"}
                    </div>
                ))}
                </td>

                <td className="border px-4 py-4">
                   {report.dcr?.retailers?.map((retailer, i) => (
                <div key={i}>
                {i + 1}. {retailer.working_with || "-"}
                </div>
            ))}
                </td>

                <td className="border px-4 py-4">
                   {report.dcr?.retailers?.map((retailer, i) => (
                    <div>
                     {retailer.remarks || "-"}
                    </div>
                ))}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="flex justify-center gap-6 mt-6">
        <CustomButton
          className="whitespace-nowrap"
          variant="print"
          onClick={handlePrint}
        >
          🖨 PRINT
        </CustomButton>

        <CustomButton
          variant="export"
          onClick={handleExport}
        >
        📥 Export
        </CustomButton>
      </div>
    </div>
  );
};

export default DoctorsInTPvsDCR;
